// extracted by mini-css-extract-plugin
export default {"spotlight":"Sportlight_spotlight__1coHB","overlay":"Sportlight_overlay__wmhDJ","content":"Sportlight_content__LN0oP"};